// [AI_START::module id="feature-flags/findFeatureFlag.ts" purpose="Fail-closed lookup of one evaluation by flagId" links=["useEvaluateFeatureFlags", "feature-flags/types.ts"]]
import { FeatureFlagResult } from "~@/feature-flags/types";

// [AI_START::function id="findFeatureFlag" purpose="Return matching evaluation or disabled default when absent" links=["useEvaluateFeatureFlags"]]
export function findFeatureFlag(
  flags: FeatureFlagResult[],
  flagId: string
): FeatureFlagResult {
  return (
    flags.find((flag) => flag.flagId === flagId) ?? {
      flagId,
      enabled: false,
      value: null,
    }
  );
}
// [AI_END::findFeatureFlag]
// [AI_END::feature-flags/findFeatureFlag.ts]
